<template>
  <div v-bind="$attrs" class="modal__overlay bg-black-60 fixed -z-1 w-full h-full top-0 left-0 right-0 bottom-0" v-on="$listeners">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>
